import { SensitiveData } from '@philips-internal/oswald-ui-constants';
import { bool, color, eventListener, expression, formatters, oneOf, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues } from '@philips-internal/oswald-ui-utils';
import { TokenShape, TokenSize } from '../token-list/token-list-constants.js';
const TokenProperties = {
    color: {
        type: color,
    },
    dismissible: {
        type: bool,
    },
    enabled: {
        defaultValue: true,
        type: bool,
    },
    formatters: {
        type: formatters,
    },
    icon: {
        type: string,
    },
    labelColor: {
        type: color,
    },
    onBeforeDismiss: {
        type: eventListener,
    },
    onClick: {
        type: eventListener,
    },
    onContextMenuClick: {
        type: eventListener,
    },
    onDismiss: {
        type: eventListener,
    },
    onDoubleClick: {
        type: eventListener,
    },
    sensitiveData: {
        defaultValue: SensitiveData.NONE,
        type: oneOf(enumValues(SensitiveData)),
    },
    shape: {
        type: oneOf(enumValues(TokenShape)),
    },
    size: {
        type: oneOf(enumValues(TokenSize)),
    },
    strikethrough: {
        type: bool,
    },
    value: {
        defaultValue: '',
        type: expression,
    },
};
export { TokenProperties, };
//# sourceMappingURL=token-types.js.map